var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLanding(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 769,
    height: 721,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M718.004 316.131c-16.743-28.74-10.319-89.234-10.319-89.234l-3.773 3.444c16.784-43.863 2.733-61.575 2.733-61.575-41.419-61.616-103.414-20.892-103.414-20.892s-45.477 7.256-28.653 61.596c1.02 3.302 1.448 7.317 1.571 11.516-.143.489-7.158 26.252-9.667 31.083-1.815 3.506 7.301 8.336 12.583 10.782 11.787 51.425 14.438 49.611 14.438 49.611 20.822.999 37.401-2.405 50.82-8.439a2636.578 2636.578 0 013.752 20.077c4.467 35.404-45.538 58.192-45.538 58.192l94.91 35.852 94.319-60.148c.02 0-53.349-6.848-73.762-41.865z",
    fill: "#fff",
    stroke: "#7AB778",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M243.291 632.017l317.318-28.821 184.334 51.465.857 13.106-317.319 28.821-184.334-51.465-.856-13.106z",
    fill: "#fff",
    stroke: "#7AB778",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M251.897 633.219l310.894-18.242-47.557-194.896-303.879 14.186 40.542 198.952z",
    fill: "#fff",
    stroke: "#7AB778",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M376.846 433.818c.489 2.141-.592 4.199-2.407 4.607-1.815.408-3.691-.978-4.18-3.119-.49-2.14.591-4.198 2.406-4.606 1.836-.408 3.691.978 4.181 3.118z",
    fill: "#7AB778"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M211.355 434.267l303.879-14.186-303.879 14.186 40.542 198.952-8.586-.856L205.604 440.3l5.751-6.033z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M211.355 434.267l303.879-14.186-303.879 14.186zm0 0l40.542 198.952-8.586-.856L205.604 440.3l5.751-6.033z",
    stroke: "#7AB778",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M234.868 450.124l265.785-12.535 35.382 154.03-266.824 23.929-34.343-165.424z",
    fill: "#D1E3CD",
    stroke: "#7AB778",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M243.291 632.017l184.354 51.465 317.298-28.82-184.334-51.466-317.318 28.821z",
    fill: "#fff",
    stroke: "#7AB778",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M380.19 661.775l-91.891-25.661 271.555-24.663 89.261 24.907-268.925 25.417z",
    fill: "#fff",
    stroke: "#7AB778",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M307.876 641.576l272.514-24.398M330.757 648.037l272.535-24.397M353.659 654.478l272.514-24.398M321.152 633.464l90.016 25.029",
    stroke: "#7AB778",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M351.599 630.835l90.036 25.009M377.743 628.287l90.036 25.009M403.908 625.739l90.036 25.029M430.052 623.191l90.036 25.03M457.399 620.969l88.833 24.704M483.441 618.401l89.751 24.928M510.054 615.976l89.322 24.826M537.096 613.673l88.384 24.581",
    stroke: "#7AB778",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M380.68 470.894l99.763-5.992c.796-.041 1.489.489 1.693 1.263l9.931 39.848a1.657 1.657 0 01-1.468 2.059l-82.144 6.033a1.71 1.71 0 00-.979.428l-12.582 14.532a1.66 1.66 0 01-2.753-.958l-13.031-55.236a1.67 1.67 0 011.57-1.977zM395.75 545.983l102.68-7.909 6.852 23.623-4.772.51-4.69.489-93.952 8.438-6.118-25.151zM377.376 570.972l-22.82-99.365-71.519 2.956-10.237 6.685 21.617 104.175 72.742-7.766 10.217-6.685z",
    fill: "#fff",
    stroke: "#7AB778",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M283.037 474.563l71.519-2.956 22.82 99.365-72.722 7.765-21.617-104.174z",
    fill: "#fff",
    stroke: "#7AB778",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M294.417 585.423l10.237-6.686",
    stroke: "#7AB778",
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M330.207 472.627L334 492.988a.609.609 0 001.101.225l3.243-4.79c.244-.367.754-.428 1.101-.143l4.445 3.751c.449.366 1.102-.021.979-.592l-4.262-19.241-10.4.429z",
    fill: "#7AB778"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M307.183 517.305l44.885-3.506M308.671 526.925l44.865-3.506M417.653 483.287l15.111-1.081M418.142 489.931l56.102-2.915M419.039 496.943l56.102-2.915",
    stroke: "#7AB778",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M409.087 490.013c1.061 4.667-1.305 9.192-5.281 10.089-3.977.917-8.076-2.14-9.136-6.808-1.061-4.667 1.305-9.192 5.281-10.089 3.977-.897 8.076 2.14 9.136 6.808z",
    fill: "#fff",
    stroke: "#7AB778",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M408.7 554.421c.265 1.182-.326 2.324-1.346 2.568-1.02.224-2.039-.55-2.325-1.732-.265-1.182.327-2.324 1.346-2.568 1.02-.225 2.06.55 2.325 1.732zM416.103 553.565c.265 1.182-.326 2.324-1.346 2.568-1.02.224-2.039-.55-2.325-1.732-.265-1.183.326-2.324 1.346-2.569 1.02-.224 2.06.551 2.325 1.733zM423.505 552.729c.266 1.182-.326 2.324-1.345 2.568-1.02.225-2.04-.55-2.325-1.732-.265-1.182.326-2.324 1.346-2.568.999-.224 2.039.55 2.324 1.732z",
    fill: "#7AB778"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M788.666 375.219s-4.14-22.42-6.383 55.95c-2.08 73.356-2.896 150.34-2.896 150.34s-39.767 1.162-82.327 19.73l-27.551 11.435s71.519 39.582 122.42 55.399c46.884 14.553 51.268-21.218 45.681-108.128 0-.021-26.654-178.53-48.944-184.726z",
    fill: "#fff",
    stroke: "#7AB778",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M600.58 128.837s-59.752 31.858-25.553 63.838l40.603-40.561-15.05-23.277zM689.902 281.44s13.439-.347 21.474 17.834c0 0-8.81-20.647 6.566-37.727l-28.04 19.893z",
    fill: "#7AB778"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M600.58 128.837s-73.09 71.542-29.285 51.486c91.525-41.886 86.834 63.654 86.834 63.654s12.603-11.475 7.954.53l23.839 36.933s50.963-19.262 53.675-83.405c.918-21.666-20.413-121.01-143.017-69.198z",
    fill: "#7AB778"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M631.944 171.273c1.367 10.945 0 54.666 19.333 57.866 19.333 3.2-3.324-54.89-3.324-54.89l-16.009-2.976z",
    fill: "#7AB778"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M570.54 406.2c-23.146 103.971-33.852 211.386-33.852 211.386s-45.722-12.963-89.098-19.975l-47.394-12.718c-1.529-.693-17.966-8.276-23.289-13.534-5.588-5.544-8.667 9.702.122 16.652a86.076 86.076 0 016.383 5.565l-11.42 1.773a10.074 10.074 0 00-5.261 2.507c-7.953 7.215-33.894 31.144-28.979 32.632 1.224.367 2.59.387 4.079.163-8.871 7.317-9.565 14.961-7.097 15.205 3.711.388 8.402-2.283 13.072-6.053-4.099 4.749-9.197 15.225-3.508 14.96 7.627-.346 14.031-6.277 20.128-16.305 0 0-1.509 2.608-.836 1.997l-4.527 7.317s9.218 8.092 15.927 11.863c6.404 3.587 10.136-9.621 1.081-15.063 0 0 3.263-3.261 5.894-10.211 0 0 25.43 12.29 38.42 2.547l8.504.816c22.208 13.901 135.003 64.571 150.461 63.409 35.097-2.609 41.766-71.583 58.733-222.331.02.041-57.162-119.237-67.543-72.602z",
    fill: "#fff",
    stroke: "#7AB778",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M536.688 617.566s-10.931 5.809-13.133 21.951",
    stroke: "#7AB778",
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M813.668 559.394c18.089-2.996 47.292-12.983 47.312-13.085 0 0-11.196-141.026-46.802-182.789-1.815-3.893-7.79-11.944-26.899-14.757a263.385 263.385 0 01-16.579-3.017c-18.68-4.015-33.894-9.6-38.238-12.351 0 0 .021.163.062.428-.102-.062-.225-.123-.327-.184 0 0 .857 3.771-.489 8.173-.123.388-.245.775-.408 1.183a5.634 5.634 0 01-.224.509c-.286.632-.592 1.284-.979 1.916-5.833 9.621-44.519 13.493-83.184-6.93 0 0-66.421 37.646-84.122 50.711-27.164 57.846-38.829 188.476-38.829 182.402 0-1.651 55.347 27.333 91.321 28.903.204 10.252-8.81 139.741-8.81 139.741s156.416 7.99 225.712-28.861c0 0-27.306-90.926-24.105-116.302.449-3.017 4.813-28.291 5.588-35.69z",
    fill: "#D1E3CD",
    stroke: "#7AB778",
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M606.983 128.001s-76.597-17.855-71.784 1.855c4.833 19.71 24.635 36.913 24.635 36.913s-22.575-.571-10.727 10.884c11.849 11.455 21.76 10.599 21.76 10.599l36.116-60.251z",
    fill: "#7AB778"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M644.323 304.044s7.872-1.977 22.331-14.533",
    stroke: "#7AB778",
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M658.456 211.304s-5.323-98.651-57.203-86.543",
    stroke: "#fff",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M689.359 239.705c1.18-18.31-12.349-34.087-30.22-35.237-17.87-1.151-33.314 12.759-34.494 31.069-1.181 18.31 12.349 34.087 30.22 35.238 17.87 1.15 33.314-12.76 34.494-31.07z",
    fill: "#D1E3CD",
    stroke: "#7AB778",
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M678.889 238.535c-.856 13.147-11.379 23.175-23.533 22.4-12.155-.774-21.311-12.087-20.475-25.233.857-13.147 11.379-23.175 23.534-22.4 12.154.794 21.331 12.086 20.474 25.233z",
    fill: "#fff",
    stroke: "#7AB778",
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M585.835 228.079c.021 2.649 1.693 4.79 3.732 4.769 2.04-.02 3.671-2.181 3.651-4.83-.021-2.65-1.693-4.79-3.732-4.77-2.04 0-3.671 2.161-3.651 4.831zM603.863 214.137c-2.978-4.076-7.199-5.523-10.564-6.604-3.732-1.202-7.403-2.405-8.973-.672-.938 1.039-.999 2.996-.183 4.219 1.121 1.732 3.65 1.651 6.016 1.895 9.156.958 14.397 6.441 15.437 5.096.571-.775-.938-2.833-1.733-3.934z",
    fill: "#7AB778"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M586.508 275.733s10.054-.408 16.6-7.114M548.393 113.693c.673-.082 30.855-8.296 53.716 17.508M729.403 132.282l-2.324 23.521s6.056-11.659 18.068-3.791",
    stroke: "#7AB778",
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M578.473 157.78s-25.593 36.138-12.541 36.077c19.72-.102 39.216-25.723 35.647-27.048-3.569-1.345-23.106-9.029-23.106-9.029z",
    fill: "#7AB778"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M347.826 639.803l10.013-21.239 10.87-8.601",
    fill: "#fff"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M347.826 639.803l10.013-21.239 10.87-8.601M341.831 630.631l11.624-13.147",
    stroke: "#7AB778",
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M383.372 612.592l-12.97 9.193-6.812 18.69",
    fill: "#fff"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M383.372 612.592l-12.97 9.193-6.812 18.69",
    stroke: "#7AB778",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M562.832 389.201s82.592-20.423 80.757 84.139l-3.793 125.352s-15.418 3.179-31.447 1.304",
    stroke: "#7AB778",
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M383.412 593.555l14.153-2.038M92.626 635.869h151.521",
    stroke: "#7AB778",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M536.708 312.38a5.012 5.012 0 01-5.017 5.014 5.011 5.011 0 01-5.016-5.014 5.011 5.011 0 015.016-5.014 5.012 5.012 0 015.017 5.014zM253.034 152.014a5.012 5.012 0 01-5.017 5.014 5.012 5.012 0 01-5.017-5.014 5.012 5.012 0 015.017-5.014 5.012 5.012 0 015.017 5.014zM479.077 157.168a5.012 5.012 0 01-5.017 5.015 5.012 5.012 0 01-5.016-5.015 5.011 5.011 0 015.016-5.014 5.012 5.012 0 015.017 5.014zM297.516 302.373a5.011 5.011 0 01-5.016 5.014 5.012 5.012 0 01-5.017-5.014 5.012 5.012 0 015.017-5.015 5.012 5.012 0 015.016 5.015zM430.031 252.803c6.424-.347 11.522-5.626 11.522-12.128 0-6.706-5.445-12.148-12.154-12.148-1.223 0-2.406.184-3.528.53-2.06-8.479-9.687-14.797-18.823-14.797-9.054 0-16.62 6.196-18.762 14.573a11.526 11.526 0 00-2.671-.306c-6.709 0-12.154 5.442-12.154 12.148 0 6.38 4.935 11.618 11.195 12.107l45.375.021zM492.577 42.783c6.689-.347 12.012-5.87 12.012-12.658 0-7.011-5.69-12.678-12.705-12.678-1.285 0-2.508.184-3.671.55-2.162-8.866-10.115-15.45-19.639-15.45-9.442 0-17.354 6.482-19.597 15.226a12.635 12.635 0 00-2.794-.326c-7.016 0-12.705 5.687-12.705 12.678 0 6.665 5.159 12.128 11.685 12.637l47.414.02z",
    fill: "#fff",
    stroke: "#7AB778",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M695.938 0v5.748M677.584 10.11l4.976 2.874M677.176 31.063l4.976-2.874M695.122 41.886v-5.748M713.476 31.776l-4.996-2.874M713.884 10.823l-4.996 2.874M353.557 88.684v5.768M335.203 98.814l4.976 2.874M334.795 119.746l4.976-2.873M352.741 130.59v-5.748M371.095 120.46l-4.996-2.874M371.503 99.527l-4.996 2.874M394.955 330.765v5.768M376.601 340.895l4.976 2.874M376.173 361.828l4.996-2.874M394.119 372.671v-5.768M412.473 362.541l-4.976-2.874M412.881 341.609l-4.976 2.874",
    stroke: "#7AB778",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M86.875 578.778c22.402 0 40.562-2.82 40.562-6.298 0-3.479-18.16-6.298-40.562-6.298-22.402 0-40.562 2.819-40.562 6.298 0 3.478 18.16 6.298 40.562 6.298z",
    fill: "#7AB778"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M76.76 648.037h20.23c7.525-.428 13.827-1.304 17.763-2.446l11.236-72.846h-.122c0 3.342-17.457 6.053-38.992 6.053-21.535 0-38.992-2.711-38.992-6.053h-.122l11.236 72.846c3.936 1.142 10.238 2.018 17.763 2.446z",
    fill: "#fff",
    stroke: "#7AB778",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M30.12 485.671c-16.07 0-29.1 13.025-29.1 29.086 0 2.629.387 5.177 1.04 7.603a6.606 6.606 0 012.977-.714 6.808 6.808 0 016.811 6.808 6.736 6.736 0 01-3.262 5.788c5.322 5.871 12.99 9.56 21.535 9.56 16.07 0 29.1-13.025 29.1-29.086-.02-16.041-13.05-29.045-29.1-29.045z",
    fill: "#D1E3CD",
    stroke: "#7AB778",
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M51.778 506.726a4.012 4.012 0 01-4.017 4.016 4.012 4.012 0 01-4.018-4.016 4.011 4.011 0 014.018-4.015 4.011 4.011 0 014.017 4.015z",
    fill: "#fff",
    stroke: "#7AB778",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M154.629 512.199c9.106-13.236 5.753-31.345-7.491-40.446-13.243-9.102-31.361-5.75-40.468 7.486-9.106 13.237-5.752 31.345 7.491 40.447 13.243 9.101 31.362 5.75 40.468-7.487z",
    fill: "#D1E3CD",
    stroke: "#7AB778",
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M128.885 496.046s-41.847 24.316-38.36 72.826",
    stroke: "#7AB778",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M73.415 486.588c11.441 11.272 29.856 11.15 41.134-.285 11.277-11.434 11.155-29.84-.286-41.111-11.441-11.272-29.856-11.149-41.133.285-11.277 11.414-11.155 29.84.285 41.111z",
    fill: "#D1E3CD",
    stroke: "#7AB778",
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M92.585 467.164s-29.101 71.909-2.263 107.986M31.12 514.736s45.762 15.736 51.778 64.022",
    stroke: "#7AB778",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M120.075 508.051c16.07 0 29.101 13.024 29.101 29.086 0 2.629-.387 5.177-1.04 7.602a6.615 6.615 0 00-2.977-.713c-3.773 0-6.832 3.057-6.832 6.808a6.735 6.735 0 003.263 5.788c-5.323 5.87-12.991 9.56-21.535 9.56-16.07 0-29.101-13.025-29.101-29.086.04-16.021 13.051-29.045 29.121-29.045z",
    fill: "#D1E3CD",
    stroke: "#7AB778",
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M98.418 529.106a4.01 4.01 0 004.017 4.015 4.01 4.01 0 004.017-4.015 4.01 4.01 0 00-4.017-4.015 4.024 4.024 0 00-4.017 4.015z",
    fill: "#fff",
    stroke: "#7AB778",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M125.989 530.777s-32.303 12.841-40.236 46.513",
    stroke: "#7AB778",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })));
}

export default SvgLanding;